import React, { useContext, useEffect, useState } from 'react'
import { AuthFetch,Fetch } from '../../services/api';
import { UserContext } from '../../context/provider/UserProvider';
import { notify } from '../../utils/utils';
import { is } from 'date-fns/locale';

const urlBaseRepuestos = process.env.REACT_APP_TMAN_API + '/Replacement'


export const useRepuestos = () => {
    const { stateUser , signOut } = useContext(UserContext);
	const codEmpresa = stateUser.codEmpresa

	const repuestoDefault = {
		codEmpresa: codEmpresa,
		codigoBarra: '',
		nombreRepuesto: '',
		codRepuestoMarca: 0,
		codRepuestoSistema: 0,
		codRepuestoDuracionTipo: 0,
		duracion: 0,
		codRepuestoUM: 0,
		caracteristicas: '',
		stockMinimo: 0,
		stockMaximo: 0,
		codMoneda: 0,
		precioCosto: 0,
		precioVenta: 0,
		urlImagen: '',
		codUsuarioAccion: stateUser.codUsuario,
		registraSerie: false,
		garantia: '',
		codRepuestoTipo: 0,
		codRepuesto: 0,
		marca: '',
		afectaNeumatico: false
	}

	const [repuesto,setRepuesto] = useState(repuestoDefault)
	const [repuestos,setRepuestos] = useState([])
	const [repuestosActivos,setRepuestosActivos] = useState([])
	const [tipoSistemas,setTipoSistemas] = useState([])
	const [unidadesMedida,setUnidadesMedida] = useState([])
	const [codigoRepuestoActual,setCodigoRepuestoActual] = useState(0)
	const [tipoDuracion,setTipoDuracion] = useState([])
	const [listaDetalleAlmacenPorRepuesto,setListaDetalleAlmacenPorRepuesto] = useState([])
	const [listaDetalleAlmacenPorNombre,setListaDetalleAlmacenPorNombre] = useState([])

	const [listaArticulos,setListaArticulos] = useState([])
	const [almacenes,setAlmacenes] = useState([])

	
	
	const listarRepuestos = async (CodRepuestoTipo) => {
		const parametros = new URLSearchParams({
			codEmpresa: codEmpresa,
			codRepuestoTipo: CodRepuestoTipo || 0
		})
		const response = await AuthFetch({
			url: urlBaseRepuestos + '?' + parametros,
		})
		if(response.isValid){
			setRepuestos(response.content.reverse())
		}else{
			notify(response.exceptions[0].description,'error')
		}
	}

	const resgistrarEditarRepuesto = async (urlImagen) => {
		const esGuardar = repuesto.codRepuesto === 0
		const {codRepuesto,...propiedadesRegistroRepuesto} = {...repuesto}
		const camposFaltantes = []

		// VALIDACION CUANDO CONTIENE IMAGEN
		urlImagen && (propiedadesRegistroRepuesto.urlImagen = urlImagen)

		if(repuesto.codRepuestoTipo == 1){		// 	SOLO HACE ESTA VALIDACION CUANDO ES DEL TIPO BIEN 
			repuesto.codigoBarra == '' 		&& camposFaltantes.push('Código de fabrica') 
			repuesto.marca == '' 			&& camposFaltantes.push('Marca')
		}
		repuesto.codRepuestoTipo == 0 		&& camposFaltantes.push('Tipo de repuesto')
		repuesto.codRepuestoSistema == 0 	&& camposFaltantes.push('Tipo de sistema') 
		repuesto.codRepuestoUM == 0 		&& camposFaltantes.push('Unidad de medida')
		repuesto.nombreRepuesto == '' 		&& camposFaltantes.push('Nombre')
		repuesto.codMoneda == 0 			&& camposFaltantes.push('Tipo moneda')
		repuesto.precioCosto == 0 			&& camposFaltantes.push('Precio de costo')
		repuesto.precioVenta == 0 			&& camposFaltantes.push('Precio de venta')
		// repuesto.codRepuestoDuracionTipo == 0 && camposFaltantes.push('Tipo de duración')
		// repuesto.duracion == 0 && camposFaltantes.push('Duración')
		
		if(camposFaltantes.length == 0){
			const response = await AuthFetch({
				url: urlBaseRepuestos,
				method: esGuardar ? 'POST' : 'PUT',
				body: JSON.stringify(esGuardar 
				?	propiedadesRegistroRepuesto
				:	(urlImagen 
					? 	{...repuesto,urlImagen: urlImagen} 
					: 	repuesto)
				)
			})
			
			return {
				CodResultado: response.isValid ? 1 : 0,
				DesResultado: response.isValid ? response.content : response.exceptions[0].description
			}
		}else{
			return {
				CodResultado: 0,
				DesResultado: `Los siguientes campos son obligatorios: ${camposFaltantes.join(', ')}`
			}
		}
	}

	const anularRepuesto = async (codRepuesto, motivoAnulacion) => {
		const response = await AuthFetch({
			url: urlBaseRepuestos,
			method: 'DELETE',
			body: JSON.stringify({
				codEmpresa: codEmpresa,
				codRepuesto: codRepuesto,
				codUsuarioAccion: stateUser.codUsuario,
				motivoAnulacion: motivoAnulacion
			})
		})
		return {
			CodResultado: response.isValid ? 1 : 0,
			DesResultado: response.isValid ? response.content : response.exceptions[0].description
		}
	}

	const comboRepuestosActivos = async () => {
		const response = await AuthFetch({
			url: urlBaseRepuestos + '/active?' + new URLSearchParams({
				codEmpresa: codEmpresa
			}),
		})
		if(response.isValid){
			setRepuestosActivos(response.content)
		}else{
			notify(response.exceptions[0].description,'error')
		}
	}

	const comboTipoSistema = async () => {
		const response = await AuthFetch({
			url: urlBaseRepuestos + '/typeSystem?' + new URLSearchParams({
				codEmpresa: codEmpresa
			})
		})
		if(response.isValid){
			setTipoSistemas(response.content)
		}else{
			notify(response.exceptions[0].description,'error')
		}
	}

	const comboUnidadMedida = async () => {
		const response = await AuthFetch({
			url: urlBaseRepuestos + '/typeMeasure?' + new URLSearchParams({
				codEmpresa: codEmpresa
			})
		})
		if(response.isValid){
			setUnidadesMedida(response.content)
		}else{
			notify(response.exceptions[0].description,'error')
		}
	}

	const obtenerCodigoRepuestoActual = async (codRepuestoSistema) => {
		const response = await AuthFetch({
			url: urlBaseRepuestos + '/queryCurrentCode?' + new URLSearchParams({
				codEmpresa: codEmpresa,
				codRepuestoSistema: codRepuestoSistema
			})
		})
		if(response.isValid){
			setCodigoRepuestoActual(response.content.codigoInternoActual)
		}else{
			notify(response.exceptions[0].description,'error')
		}
	}

	const obtenerTipoDuracion = async () => {
		const response = await AuthFetch({
			url: urlBaseRepuestos + '/typeDuration?' + new URLSearchParams({
				codEmpresa: codEmpresa
			})
		})
		if(response.isValid){
			setTipoDuracion(response.content)
		}else{
			notify(response.exceptions[0].description,'error')
		}
	}

	const detalleAlmacenPorRepuesto = async (codRepuesto) => {
		const response = await AuthFetch({
			url: urlBaseRepuestos + '/detail?' + new URLSearchParams({
				codEmpresa: codEmpresa,
				codRepuesto: codRepuesto
			})
		})
		if(response.isValid){
			setListaDetalleAlmacenPorRepuesto(response.content)
		}else{
			notify(response.exceptions[0].description,'error')
		}
	}

	const detalleAlmacenPorNombre = async (texto,codAlmacen) => {
		const response = await AuthFetch({
			url: urlBaseRepuestos + '/productoDetailStore?' + new URLSearchParams({
				codEmpresa: codEmpresa,
				texto: texto,
				codAlmacen: codAlmacen
			})
		})
		if(response.isValid){
			setListaDetalleAlmacenPorNombre(response.content)
		}else{
			notify(response.exceptions[0].description,'error')
		}
	}

	//	VALIDAR ENDPOINT /api/Rep1acement/productDiagnosisWorkshop

	const listarTipoArticulos = async () => {
		const response = await AuthFetch({
			url: urlBaseRepuestos + '/type?' + new URLSearchParams({
				codEmpresa: codEmpresa
			})
		})
		if(response.isValid){
			setListaArticulos(response.content)
		}else{
			notify(response.exceptions[0].description,'error')
		}
	}

	const activarRepuesto = async (codRepuesto) => {
		const response = await AuthFetch({
			url: urlBaseRepuestos + '/activate',
			method: 'PUT',
			body: JSON.stringify({
				codEmpresa: codEmpresa,
				codRepuesto: codRepuesto
			})
		})
		
		return {
			CodResultado: response.isValid ? 1 : 0,
			DesResultado: response.isValid ? response.content : response.exceptions[0].description
		}
	}

	const editarImagenProducto = async (codRepuesto,urlImagen) => {
		const response = await AuthFetch({
			url: urlBaseRepuestos + '/productImage',
			method: 'PUT',
			body: JSON.stringify({
				codEmpresa: codEmpresa,
				codRepuesto: codRepuesto,
				urlImagen: urlImagen
			})
		})
		
		return {
			CodResultado: response.isValid ? 1 : 0,
			DesResultado: response.isValid ? response.content : response.exceptions[0].description
		}
	}

	const cantidadesAlmacenesRepuestos = async (listaRepuesto,codAlmacen) => {
		const response = await AuthFetch({
			url: urlBaseRepuestos + '/spareStockQuantity',
			method: 'PUT',
			body: JSON.stringify({
				codEmpresa: codEmpresa,
				listaRepuesto: listaRepuesto,
				codAlmacen: codAlmacen
			})
		})
		
		return {
			CodResultado: response.isValid ? 1 : 0,
			DesResultado: response.isValid ? response.content : response.exceptions[0].description
		}
	}

	const comboAlmacen = async () => {
		const response = await AuthFetch({
			url: urlBaseRepuestos + '/store?' + new URLSearchParams({
				codEmpresa: codEmpresa
			})
		})
		if(response.isValid){
			setAlmacenes(response.content)
		}else{
			notify(response.exceptions[0].description,'error')
		}
	}


	const editarValorRepuesto = (key,value) => {
		setRepuesto(repuesto => {
			return {
				...repuesto,
				[key]: value
			}
		})
	}

	return ({
		listarRepuestos,
		repuestos,
		repuesto,
		setRepuesto,
		repuestoDefault,
		editarValorRepuesto,
		resgistrarEditarRepuesto,
		anularRepuesto,
		comboRepuestosActivos,
		repuestosActivos,
		comboTipoSistema,
		tipoSistemas,
		comboUnidadMedida,
		unidadesMedida,
		obtenerCodigoRepuestoActual,
		codigoRepuestoActual,
		obtenerTipoDuracion,
		tipoDuracion,
		detalleAlmacenPorRepuesto,
		listaDetalleAlmacenPorRepuesto,
		detalleAlmacenPorNombre,
		listaDetalleAlmacenPorNombre,

		listarTipoArticulos,
		listaArticulos,
		activarRepuesto,
		editarImagenProducto,
		cantidadesAlmacenesRepuestos,
		comboAlmacen,
		almacenes
	})
}
